// recovery-report-01 — relatório de Recuperação de Clientes (resumo em cartões, colunas novas)
const catalogo: Record<string, string> = {
    "%{level} · nível %{order} de %{total}": "%{level} · nivel %{order} de %{total}",
    "%{n} sem cupom": "%{n} sin cupón",
    "%{rate} do público": "%{rate} del público",
    "%{value} por trazido": "%{value} por cliente traído",
    "30 dias seguintes": "30 días siguientes",
    "Campanha sem níveis.": "Campaña sin niveles.",
    "Não começou": "No empezó",
    "Receita com cupom": "Ingreso con cupón",
    "Retorno por R$": "Retorno por R$",
    "Sem desconto": "Sin descuento",
    "Total do período (%{n} campanhas)": "Total del período (%{n} campañas)",
    "em andamento": "en curso",
    "fim previsto": "fin previsto",
};

export default catalogo;
